var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal-fade"}},[(_vm.isModal)?_c('section',{staticClass:"main-modal fixed wh100 left0 top0 flex-center z999",on:{"mouseup":_vm.releaseClick}},[_c(_vm.componentName,{tag:"component",on:{"click":function($event){$event.stopPropagation();},"close":_vm.close}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }